import { DataProxy } from 'apollo-cache';

import { Inbox, GetInboxItemsDocument } from 'api';
import { POPUP_LIMIT } from 'features/notifications/constants';

export const markRead = (cache: DataProxy) => {
  const queryParams = {
    query: GetInboxItemsDocument,
    variables: { limit: POPUP_LIMIT },
  };

  const { getInboxItems } = cache.readQuery(queryParams);
  const data = {
    getInboxItems: {
      ...getInboxItems,
      inbox: getInboxItems.inbox.map((item: Inbox) => {
        item.item_read = true;
        return item;
      }),
    },
  };

  cache.writeQuery({ data, ...queryParams });
};
